import WebGalleryDownloadModal from './WebGalleryDownloadModal';

export default WebGalleryDownloadModal;
